import { createUseStyles } from 'react-jss';

export const useLensReturnPolicyStyles = createUseStyles({
  'return-policy': {
    '& li': {
      listStyle: 'none',
      backgroundImage: 'url("/images/icons/listing-icon.svg")',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left 8px',
      marginLeft: '10px',
      '& span': {
        marginLeft: '22px',
        display: 'inline-block',
      },
    },
  },
});
